module.exports = __webpack_public_path__ + "img/prbw-325.aa408966.png";